import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import { useStore } from '../../stores';
import FileActionPopup from '../FileActionPopup';
import SVGIcon from '../SVGIcon';
import { formatDate, formatBytes, toLowerCase } from '../../utils/formatters';
import { isImageExt, isFileApproved, isViewedFileFolder } from '../../utils/functions';

RecentFile.propTypes = {
  info: PropTypes.object.isRequired
};

const useStyles = makeStyles((theme) => ({
  unClickableText: {
    cursor: 'text'
  },
  blur: {
    opacity: '0.3'
  },
}));

function RecentFile(props) {
  const { info } = props;
  const { fileActionStore } = useStore();
  const classes = useStyles();

  info.type = 1;

  const handleViewFile = (e) => {
    e.preventDefault();

    if (!isViewedFileFolder(info.permission1)) return;

    if (toLowerCase(info.extension) === 'pdf') {
      fileActionStore.setInfo(info);
      fileActionStore.handleShowFilePDF(info.id);
    } else if (isImageExt(info.extension)) {
      fileActionStore.setInfo(info);
      fileActionStore.handleShowFileImage(info.id);
    } else {
      fileActionStore.setInfo(info);
      fileActionStore.setShowModal('Image', true)
    }
  }

  return (
    <div className="nk-file-item nk-file">
      <div className="nk-file-info">
        <div className="nk-file-title">
          <div className={`nk-file-icon ${!isFileApproved(info.isApproved, info.folderTypeRoot) ? classes.blur : ''}`}>
            <span className="nk-file-icon-type" style={{ textAlign: 'center' }}>
              <SVGIcon ext={info.extension} hardMode="list"></SVGIcon>
            </span>
          </div>
          <div className="nk-file-name">
            <div className="nk-file-name-text">
              <a
                href="# "
                className={`title`}
                onClick={handleViewFile}
              >
                {info.extension ? `${info.displayName}.${info.extension}` : info.displayName}
              </a>
            </div>
          </div>
        </div>
        <ul className="nk-file-desc">
          <li className="date">{formatDate(info.lastViewAt)}</li>
          <li className="size">{formatBytes(info.size)}</li>
          <li className="members">{info.totalMember || 0} Members</li>
        </ul>
      </div>
      <div className="nk-file-actions">
        <FileActionPopup info={info}></FileActionPopup>
      </div>
    </div>
  );
}

export default RecentFile;